import MythicCommanderBanner from './MythicCommanderBanner';

export default MythicCommanderBanner;
